import React from 'react';
import MyCustomLogoFull from './zapay-icon.png';

const LogoFull = () => {
  return <img src={MyCustomLogoFull} style={{ width: '160px', height: '125px' }}/>;
};

export default LogoFull;
